import { Action, HIDE_LOGIN_WITH_2FA_RECOMENDATION } from 'actions';

interface State {
  visible: boolean;
}

const initState: State = {
  visible: true,
};

export const loginWith2FARecomendation = (state: State = initState, action: Action): State => {
  switch (action.type) {
    case HIDE_LOGIN_WITH_2FA_RECOMENDATION:
      return {
        ...state,
        visible: false,
      };
    default:
      return state;
  }
};
